module.exports = __webpack_public_path__ + "static/media/mall-image-1.66db2e09.png";